export const navItems = [
  { name: "About", href: "#about" },
  { name: "Skills", href: "#skills" },
  { name: "Certifications", href: "#certifications" },
  { name: "Portfolio", href: "#portfolio" }
]

export const footerLinks = [
  "About",
  "Skills",
  "Portfolio",
  "Contact"
]
